import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { baseUrl_ } from '../../utils/constants';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const postRequest = (url: string, details: any, token?: string) => ({
  url,
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    sessId: localStorage.getItem('sessId') ?? '',
  },
  body: details,
});

const putRequest = (url: string, details: any, token?: string) => ({
  url,
  method: 'PATCH',
  headers: {
    Authorization: `Bearer ${token}`,
    sessId: localStorage.getItem('sessId') ?? '',
  },
  body: details,
});

const getRequest = (url: string, token?: string) => ({
  url,
  headers: {
    Authorization: `Bearer ${token}`,
    sessId: localStorage.getItem('sessId') ?? '',
  },
});

export const businessInformation = createApi({
  reducerPath: 'businessInformation',
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl_,
  }),
  tagTypes: ['Info'],
  endpoints: (builder) => ({
    getBusinessInformation: builder.query({
      query: (credential) => getRequest('/user/businessinfo', credential.token),
      providesTags: ['Info'],
    }),
    updateBusinessInformation: builder.mutation({
      query: (credential) => putRequest('/user/businessinfo', credential.body, credential.token),
      invalidatesTags: ['Info'],
    }),
  }),
});

export const { useGetBusinessInformationQuery, useUpdateBusinessInformationMutation } =
  businessInformation;
